/* Lune Soie — Global behaviors */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ========= Generic drawer open/close ========= */
  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-action]');
    if (!t) return;
    const action = t.dataset.action;
    if (action === 'open-cart') { e.preventDefault(); openDrawer('CartDrawer'); refreshCartDrawer(); }
    if (action === 'close-cart') { closeDrawer('CartDrawer'); }
    if (action === 'open-search') { e.preventDefault(); openDrawer('SearchDrawer'); }
    if (action === 'close-search') { closeDrawer('SearchDrawer'); }
    if (action === 'open-mobile-menu') { e.preventDefault(); openDrawer('MobileMenu'); }
    if (action === 'close-mobile-menu') { closeDrawer('MobileMenu'); }
    if (action === 'open-quick-view') {
      e.preventDefault();
      openQuickView(t.dataset.productHandle);
    }
    if (action === 'close-quick-view') { closeDrawer('QuickView'); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      ['CartDrawer', 'SearchDrawer', 'MobileMenu', 'QuickView'].forEach(closeDrawer);
    }
  });

  /* ========= Announcement bar rotator ========= */
  const slider = $('.announcement-bar__slider');
  if (slider && slider.dataset.autoplay === 'true') {
    const items = $$('.announcement-bar__item', slider);
    if (items.length > 1) {
      items.forEach((it, i) => it.classList.toggle('is-active', i === 0));
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    }
  }

  /* ========= Cart helpers ========= */
  async function fetchCart() {
    const res = await fetch(window.routes.cart + '.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return (window.shopCurrency?.symbol || '$') + amount;
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  async function refreshCartDrawer() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    publish(PUB_SUB_EVENTS.cartUpdate, cart);

    const body = $('[data-cart-items]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="${window.routes.cart.replace('/cart','/collections/all')}" class="btn btn--primary">Shop now</a></div>`;
      const footer = $('.cart-drawer__footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    body.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-cart-line data-line-key="${item.key}">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}
        <div class="cart-line__info">
          <a href="${item.url}">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${item.variant_title}</p>` : ''}
          <div class="quantity-selector quantity-selector--sm">
            <button type="button" data-drawer-qty-decrease data-line-key="${item.key}">−</button>
            <span data-line-qty>${item.quantity}</span>
            <button type="button" data-drawer-qty-increase data-line-key="${item.key}">+</button>
          </div>
        </div>
        <div class="cart-line__price">
          <span>${formatMoney(item.final_line_price)}</span>
          <button type="button" data-drawer-remove data-line-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join('');

    const subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    const footer = $('.cart-drawer__footer');
    if (footer) footer.style.display = '';

    updateShippingBar(cart.total_price);
  }

  function updateShippingBar(total) {
    const bar = $('[data-shipping-bar]');
    if (!bar) return;
    const threshold = parseFloat(bar.dataset.threshold || '0') * 100;
    if (!threshold) return;
    const msg = $('[data-shipping-message]');
    const fill = $('[data-shipping-fill]');
    const remaining = threshold - total;
    if (remaining > 0) {
      if (msg) msg.textContent = `Add ${formatMoney(remaining)} for free shipping`;
    } else {
      if (msg) msg.textContent = '✓ You qualify for free shipping!';
    }
    if (fill) fill.style.width = Math.min(100, (total / threshold) * 100) + '%';
  }

  /* Cart line modifications via drawer */
  document.addEventListener('click', async (e) => {
    const dec = e.target.closest('[data-drawer-qty-decrease]');
    const inc = e.target.closest('[data-drawer-qty-increase]');
    const rm = e.target.closest('[data-drawer-remove]');
    if (!dec && !inc && !rm) return;

    e.preventDefault();
    const key = (dec || inc || rm).dataset.lineKey;
    const cart = await fetchCart();
    const line = cart.items.find((i) => i.key === key);
    if (!line) return;

    let qty = line.quantity;
    if (dec) qty = Math.max(0, qty - 1);
    if (inc) qty += 1;
    if (rm) qty = 0;

    await fetch(window.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await refreshCartDrawer();
  });

  /* ========= Quantity selectors (product page) ========= */
  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-qty-decrease]');
    const inc = e.target.closest('[data-qty-increase]');
    if (!dec && !inc) return;
    const wrap = (dec || inc).closest('.quantity-selector');
    const input = wrap?.querySelector('[data-qty-input]');
    if (!input) return;
    let v = parseInt(input.value || '1', 10);
    if (dec) v = Math.max(parseInt(input.min || '1', 10), v - 1);
    if (inc) v += 1;
    input.value = v;
  });

  /* ========= Product variant options ========= */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-option-button]');
    if (!btn) return;
    e.preventDefault();
    const group = btn.closest('.product-option');
    $$('[data-option-button]', group).forEach((b) => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    const label = group.querySelector('[data-option-value]');
    if (label) label.textContent = btn.dataset.optionValue;
    syncSelectedVariant();
  });

  function syncSelectedVariant() {
    const jsonEl = $('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const selected = $$('.product-option').map((opt) => {
      const sel = opt.querySelector('[data-option-button].is-selected');
      return sel ? sel.dataset.optionValue : null;
    });
    const variant = product.variants.find((v) =>
      v.options.every((val, i) => selected[i] === null || val === selected[i])
    );
    if (variant) {
      const idInput = $('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      const priceEl = $('[data-product-price]');
      if (priceEl) {
        let html = `<span class="price">${formatMoney(variant.price)}</span>`;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = `<span class="price price--sale">${formatMoney(variant.price)}</span><s class="price price--compare">${formatMoney(variant.compare_at_price)}</s>`;
        }
        priceEl.innerHTML = html;
      }

      const btn = $('[data-add-to-cart]');
      if (btn) {
        btn.disabled = !variant.available;
        btn.querySelector('span').textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      publish(PUB_SUB_EVENTS.variantChange, { variant });
    }
  }

  /* ========= AJAX add-to-cart from cards & main form ========= */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="' + window.routes.cartAdd + '"], form[action$="/cart/add"], form.product-form, form[data-quick-add]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.innerHTML; submitBtn.innerHTML = '<span>Adding...</span>'; }

    const formData = new FormData(form);
    try {
      const res = await fetch(window.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      const data = await res.json();
      if (!res.ok) {
        publish(PUB_SUB_EVENTS.cartError, data);
        alert(data.description || data.message || 'Could not add to cart');
      } else {
        await refreshCartDrawer();
        openDrawer('CartDrawer');
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = submitBtn.dataset.originalText || '<span>Add to cart</span>';
      }
    }
  });

  /* ========= Quick view ========= */
  async function openQuickView(handle) {
    if (!handle) return;
    openDrawer('QuickView');
    const target = $('[data-quick-view-content]');
    if (target) target.innerHTML = '<p>Loading...</p>';
    try {
      const res = await fetch(`/products/${handle}?view=quick-view`);
      const text = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = text;
      // Try to extract main product block, else dump everything
      const main = tmp.querySelector('.product') || tmp;
      if (target) target.innerHTML = main.outerHTML;
      // Re-init: the JSON tag inside the cloned content may collide with the page one — strip & rely on cart-add submit handler.
    } catch (e) {
      if (target) target.innerHTML = '<p>Sorry, this product could not be loaded.</p>';
    }
  }

  /* ========= Predictive search ========= */
  let predictiveTimer;
  const searchInput = $('.search-drawer__form input[name="q"]');
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      clearTimeout(predictiveTimer);
      const q = searchInput.value.trim();
      const results = $('[data-predictive-results]');
      if (!results) return;
      if (q.length < 2) { results.innerHTML = ''; return; }
      predictiveTimer = setTimeout(async () => {
        try {
          const res = await fetch(`${window.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const html = await res.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          // Storefront returns a fragment of HTML
          results.innerHTML = tmp.innerHTML;
        } catch (e) { /* ignore */ }
      }, 250);
    });
  }

  /* ========= Initial cart count ========= */
  fetchCart().then((cart) => updateCartCount(cart.item_count)).catch(() => {});
})();
